import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./account/auth";
import { useSelector } from "react-redux";
import { navbarData } from "../utils/consts";
const Navbar = () => {
  const [navbar, setNavbar] = useState(false);

  const { admin } = useAuth();
  console.log(admin, "isadmin");

  const user = useSelector((state) => state.me.data);

  console.log(user);

  return (
    <>
      <nav className="w-full bg-white shadow">
        <div
          className={`justify-between px-4 mx-auto  relative md:items-center md:flex md:px-8 lg:max-w-7xl `}
        >
          <div>
            <div
              className={`flex items-center justify-between py-3 ${
                 "md:py-2 md:block"
              }`}
            >
              <Link to={admin ? "/" : "/profile"}>
                <a href="javascript:void(0)">
                  <img src="/incubation.png" className="w-24" />
                </a>
              </Link>
              <div className="md:hidden">
                <button
                  className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                  onClick={() => setNavbar(!navbar)}
                >
                  {navbar ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
          <div>
            <div
              className={`flex-1 text-center justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
                navbar ? "block" : "hidden"
              }`}
            >
              <ul
                className={
                  "items-center justify-center space-y-8 md:flex md:space-x-5 lg:space-x-6 md:space-y-0"
                }
              >
                {/* <li className="text-gray-600 text-sm lg:text-base font-medium hover:text-primary">
                   <Link onClick={() => {localStorage.removeItem('token')}} to={"/login"}>
                        <a href="javascript:void(0)">Chiqish</a>
                   </Link>
                </li> */}
                {user &&
                  navbarData.map((item) => {
                    if (item.role.includes(user?.role)) {
                      return (
                        <li
                          className={
                            "text-gray-600 text-sm lg:text-base font-medium hover:text-primary"
                          }
                        >
                          <Link to={item.url}>
                            <a href="javascript:void(0)">
                              {item.name ? (
                                item.name
                              ) : (
                                <img
                                  className="rounded-full h-10 inline-block"
                                  src={"/blue-avatar.jpg"}
                                />
                              )}
                            </a>
                          </Link>
                        </li>
                      );
                    }
                  })}
                {/* <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link to={"/"}>
                  <a href="javascript:void(0)">Bosh sahifa</a>
                  </Link>
                </li>
                <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link to={"/users"}>
                  <a href="javascript:void(0)">Foydalanuvchilar</a>
                  </Link>
                </li>
                <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link to={"/events"}>
                  <a href="javascript:void(0)">Yangiliklar</a>
                  </Link>
                </li>
                <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link to={"/stuffs"}>
                  <a href="javascript:void(0)">Hodimlar</a>
                  </Link>
                </li>
                <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link to={"/categories"}>
                  <a href="javascript:void(0)">Kategoriyalar</a>
                  </Link>
                </li>
                <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link to={"/status"}>
                  <a href="javascript:void(0)">Statuslar</a>
                  </Link>
                </li>
                <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link to={"/calendar"}>
                  <a href="javascript:void(0)">Kalendar</a>
                  </Link>
                </li>
                <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link to={"/statistics"}>
                  <a href="javascript:void(0)">Statistika</a>
                  </Link>
                </li>
                <li className={admin ? "text-gray-600 text-sm lg:text-base font-medium hover:text-primary" : 'hidden'}>
                  <Link className="inline-block" to={"/profile"}>
                  <img className="rounded-full h-10" src="/blue-avatar.jpg" />
                  </Link>

                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
export default Navbar;




// {
//   user?.role == "admin" ? (
//     <div
//   className={` w-[200px] md:w-[300px] h-screen  overflow-y-auto fixed right-0 top-0 p-4  bg-white z-[20] ${
//     navbar ? "block" : "hidden"
//   }`}
// >
//   <button onClick={() => {setNavbar(false)}} className="ml-auto w-fit block p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border">
//   <svg
//           xmlns="http://www.w3.org/2000/svg"
//           className="w-6 h-6"
//           viewBox="0 0 20 20"
//           fill="currentColor"
//         >
//           <path
//             fillRule="evenodd"
//             d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
//             clipRule="evenodd"
//           />
//         </svg>
//   </button>
//   <ul
//     className={
//       "items-center justify-center space-y-8  "
//     }
//   >
//     {/* <li className="text-gray-600 text-sm lg:text-base font-medium hover:text-primary">
//        <Link onClick={() => {localStorage.removeItem('token')}} to={"/login"}>
//             <a href="javascript:void(0)">Chiqish</a>
//        </Link>
//     </li> */}
//     {user &&
//       navbarData.map((item) => {
//         if (item.role.includes(user?.role)) {
//           return (
//             <li
//               className={
//                 "text-gray-600 text-sm lg:text-base font-medium hover:text-primary"
//               }
//             >
//               <Link to={item.url}>
//                 <a href="javascript:void(0)">
//                   {item.name ? (
//                     item.name
//                   ) : (
//                     <img
//                       className="rounded-full h-10 inline-block"
//                       src={"/blue-avatar.jpg"}
//                     />
//                   )}
//                 </a>
//               </Link>
//             </li>
//           );
//         }
//       })}
    
//   </ul>
// </div>
//   ) : (
    
//   )
// }